import './style.modules.scss'

import { Notification } from '@ampcore/adel-react'
import { NotificationType } from '@ampcore/adel-react'
import React, { useEffect, useState } from 'react'

export type ToastProps = {
  message: string
  type: NotificationType
  testId?: string
  visible: boolean
  onClose: () => void
}

export const Toast = (props: ToastProps) => {
  const { message, type, testId, visible, onClose } = props
  const [top, setTop] = useState(10)

  const calculateTopPosition = () => {
    const minimumTop = 40
    let menuTop

    // allows for querying outside shadow root
    const appHeader = document.getElementById('app-header')
    if (appHeader) {
      menuTop = appHeader.getBoundingClientRect().bottom + 10
      if (menuTop > minimumTop) {
        return menuTop
      }
      return minimumTop
    }

    return minimumTop
  }

  useEffect(() => {
    if (visible) {
      const calculatedTop = calculateTopPosition()
      setTop(calculatedTop)

      const timer = setTimeout(() => {
        onClose()
      }, 5000)
      return () => clearTimeout(timer)
    }

    return undefined
  }, [visible, onClose])

  useEffect(() => {
    const handleScrollOrResize = () => {
      if (visible) {
        const calculatedTop = calculateTopPosition()
        setTop(calculatedTop)
      }
    }
    window.addEventListener('scroll', handleScrollOrResize)
    window.addEventListener('resize', handleScrollOrResize)

    return () => {
      window.removeEventListener('scroll', handleScrollOrResize)
      window.removeEventListener('resize', handleScrollOrResize)
    }
  }, [visible])

  if (!visible) return null

  return (
    <div
      className="Toast"
      style={{ top: top }}
      data-testid={testId ?? undefined}
    >
      <Notification
        className="u-sizeConstrained u-marginTop20"
        testId={testId ? `${testId}-notification` : undefined}
        type={type}
        dismissable={false}
        message={message}
      />
    </div>
  )
}
